import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_116: FaireProductEntity = {
  token: "catalog_prod_prod-116",
  type: "product",
  name: "Santa Nested Book Boxes (Set of 03)",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=400&h=400&fit=crop",
  priceDollars: 95.59,
  msrpDollars: 238.98,
  sku: "VI0116",
  caseSize: 6,
  material: "Ceramic",
  collectionToken: "col_vintage-holiday",
  isNew: false,
  isBestseller: true,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 417,
  description: "Beautiful Vintage Holiday piece perfect for any home.",
  categoryTokens: ["catalog_cat_crafts-hobbies"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
